import React from "react";
import loader from "../assets/loader.gif"; // Adjust the path based on your folder structure

const Loader = () => {
  return (
    <div className="fixed flex items-center justify-center right-0 bottom-0 top-0 left-0 bg-white opacity-90 z-[1201]">
      <img src={loader} alt="Loading..." className="w-[80px] h-[80px]" />
    </div>
  );
};

export default Loader;
